import { useState, useEffect } from 'react';
import './styles/global.css';

import Nav       from './components/Nav';
import Hero      from './components/Hero';
import Statement from './components/Statement';
import Pipeline  from './components/Pipeline';
import Features  from './components/Features';
import Technical from './components/Technical';
import Privacy   from './components/Privacy';
import Build     from './components/Build';
import DevelopmentJourney from './components/DevelopmentJourney';
import CTA       from './components/CTA';
import Footer    from './components/Footer';
import Modal     from './components/Modal';

import { useCursor } from './hooks/useCursor';

// Scroll reveal observer — runs once after mount
function useScrollReveal() {
  useEffect(() => {
    const observe = () => {
      const els = document.querySelectorAll('.reveal, .feature-row, .tech-decision');
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('visible');
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      els.forEach((el) => obs.observe(el));
      return obs;
    };

    // Small delay to ensure DOM is fully painted
    const timer = setTimeout(() => {
      const obs = observe();
      return () => obs.disconnect();
    }, 100);

    return () => clearTimeout(timer);
  }, []);
}

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const { dotRef, ringRef } = useCursor();

  useScrollReveal();

  return (
    <>
      {/* Custom cursor — desktop only */}
      <div className="cursor-dot"  ref={dotRef}  />
      <div className="cursor-ring" ref={ringRef} />

      <Nav       onOpenModal={() => setModalOpen(true)} />
      <Hero      onOpenModal={() => setModalOpen(true)} />
      <Statement />
      <DevelopmentJourney />
      <Pipeline  />
      <Features  />
      <Technical />
      <Privacy   />
      <Build     />
      <CTA       onOpenModal={() => setModalOpen(true)} />
      <Footer    />

      <Modal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
